import React from 'react';
import {Pane, PaneProps} from 'evergreen-ui';
import {MemoStationSearchByName} from './StationSearchByName';
import {MemoRegionSelect} from '../RegionSelect';
import {MemoCategoryTypeSelect} from '../CategoryTypeSelect';
import {useSelectedRegion, useStationSearchText} from '../hooks';
import {useSelectedTypeId} from "../hooks/useSelectedTypeId";

// TODO: ??? Перенести в компоненты станции ???

/**
 * Фильтры станции с выбранными данными из `filterSlice`
 */
export const StationsFilters = (props: PaneProps) => {
  const { regionId, onSelectRegion } = useSelectedRegion();
  const { searchText, onChangeSearchText } = useStationSearchText();
    const { typeId, onSelectType } = useSelectedTypeId();

  return (
    <Pane display="grid" gap=".2rem" gridTemplateColumns="1fr repeat(2, 1fr) max-content" {...props}>
      <MemoStationSearchByName debounceDelay={800} text={searchText} updateText={onChangeSearchText} />
      <MemoRegionSelect selected={regionId} onSelect={onSelectRegion} />
      <MemoCategoryTypeSelect selected={typeId} onSelect={onSelectType} />
    </Pane>
  );
};
export const MemoStationsFilters = React.memo(StationsFilters);
MemoStationsFilters.displayName = 'MemoStationsFilters';
export default StationsFilters;
